import { memo, useMemo } from 'react';
import { Button } from 'design-system';
import { ISLAJson, BillingUnit } from '@scale/shared/types/contract';
import { useGetDataStreams } from 'react-scale/corp/components/OTS/hooks/taskBankAPIClient';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query-v4';
import Table from 'corp/components/UI/Table';
import _ from 'lodash';

const queryClient = new QueryClient();

interface ISLALookupObjectProps {
  object: ISLAJson;
}

function SLALookupObjectComponent(props: ISLALookupObjectProps) {
  const { object } = props;
  const { _id: slaId, billingUnit } = object;

  const { data: dataStreams } = useGetDataStreams(billingUnit === BillingUnit.OTS);

  const dataPackRows = useMemo(() => {
    const dataTypeMap = new Map<string, string>();
    for (const { dataPackId, name } of dataStreams || []) {
      dataTypeMap.set(dataPackId, name);
    }
    return _.keys(object.billingSpec)
      .filter(dataPackId => dataTypeMap.has(dataPackId))
      .map(dataPackId => ({
        dataPackId,
        name: dataTypeMap.get(dataPackId),
      }));
  }, [object.billingSpec, dataStreams]);

  return (
    <div style={{ flexBasis: '200%' }}>
      <div className="flex flex-col" style={{ marginBottom: '10px' }}>
        <div style={{ marginRight: '10px' }}>
          <Button href={`/corp/sla/edit?id=${slaId}`}>Edit SLA</Button>
        </div>
        <div>
          <Button href={`/corp/sla/edit?id=${slaId}&amend=1`}>Amend SLA</Button>
        </div>
      </div>
      {dataPackRows.length > 0 && (
        <Table
          disablePagination={true}
          columns={[
            { accessor: 'dataPackId', Header: 'Data Pack ID' },
            { accessor: 'name', Header: 'Name' },
          ]}
          data={dataPackRows}
        />
      )}
    </div>
  );
}

function SLALookupObject(props: ISLALookupObjectProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <SLALookupObjectComponent {...props} />
    </QueryClientProvider>
  );
}

export default memo(SLALookupObject);
